import React from "react";
import Modal from "react-responsive-modal";
import { Box, Typography, Grid, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modalContent: {
    padding: theme.spacing(4),
    maxWidth: "700px",
    margin: "0 auto",
    borderRadius: "12px",
    position: "relative",
  },
  mediaContainer: {
    borderRadius: "12px",
    overflow: "hidden",
    marginBottom: theme.spacing(3),
    textAlign: "center",
    padding: theme.spacing(2),
  },
  imageStyle: {
    width: "400px",
    height: "300px",
    borderRadius: "12px",
    display: "block",
    margin: "0 auto",
  },
  videoStyle: {
    width: "100%",
    borderRadius: "12px",
    objectFit: "cover",
  },
  title: {
    fontWeight: 700,
    color: "#3f51b5",
    marginBottom: theme.spacing(2),
    textAlign: "center",
    fontSize: "1.8rem",
  },
  detailText: {
    color: "#555",
    marginBottom: theme.spacing(1.5),
    fontSize: "1rem",
  },
  labelText: {
    color: "#888",
    fontSize: "0.9rem",
    marginBottom: theme.spacing(0.5),
  },
}));

const AdDetailsModal = ({ open, close, ad }) => {
  const classes = useStyles();

  if (!ad) return null;

  const { ad_file, expires_at, createdAt, updatedAt } = ad;

  return (
    <Modal open={open} onClose={close} center>
      <Box className={classes.modalContent}>
        <Box className={classes.mediaContainer}>
          {ad_file ? (
            ad_file.match(/\.(jpeg|jpg|gif|png)$/) ? (
              <img src={ad_file} alt="Ad" className={classes.imageStyle} />
            ) : (
              <video controls className={classes.videoStyle}>
                <source src={ad_file} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )
          ) : (
            <Typography className={classes.detailText}>
              No media file available
            </Typography>
          )}
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Typography className={classes.labelText}>Ad ID:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {ad.ad_id}
            </Typography>

            <Typography className={classes.labelText}>Ad Level:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {ad.ad_level}
            </Typography>

            <Typography className={classes.labelText}>Price:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              ${ad.price}
            </Typography>

            <Typography className={classes.labelText}>Retail Value:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {ad.retailValueOfPublication.minimum &&
              ad.retailValueOfPublication.maximum
                ? `$${ad.retailValueOfPublication.minimum} - $${ad.retailValueOfPublication.maximum}`
                : ad.retailValueOfPublication.maximum
                ? `$${ad.retailValueOfPublication.maximum} - below`
                : `$${ad.retailValueOfPublication.minimum} - above`}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography className={classes.labelText}>Status:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {ad.status}
            </Typography>

            <Typography className={classes.labelText}>Expires At:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {expires_at ? new Date(expires_at).toLocaleString() : "N/A"}
            </Typography>

            <Typography className={classes.labelText}>Created At:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {new Date(createdAt).toLocaleString()}
            </Typography>

            <Typography className={classes.labelText}>Updated At:</Typography>
            <Typography variant="h6" className={classes.detailText}>
              {new Date(updatedAt).toLocaleString()}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AdDetailsModal;
